import * as React from 'react';
import { Box, Text, Grid } from '@chakra-ui/react';

export const Empty = () => {
  return (
    <Box textAlign="center" fontSize="xl">
      <Grid minH="100vh" p={3}>
        <Text color="text.100">Eita, parece que essa pagina não existe</Text>
      </Grid>
    </Box>
  );
};
